import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { EstimateFieldsNeedToRefresh } from "@Helpers/types/estimation/takeoffTypes";
import type {
  AdditionalCostItem,
  EstimateData,
  EstimateListItem,
  EstimateVersionEntry,
} from "@ServerTypes/estimates/estimates.schema.js";

export const estimateFieldsNeedToRefreshIntialState: EstimateFieldsNeedToRefresh = {
  takeoffs: [],
  measurements: false,
};

const estimateListSlice = createSlice({
  name: "estimateList",
  initialState: [] as EstimateListItem[],
  reducers: {
    getEstimateList: (_state, action: PayloadAction<EstimateListItem[]>) => action.payload,
    emptyEstimateList: () => [],
  },
});

const estimateErrorSlice = createSlice({
  name: "estimateError",
  initialState: false as boolean | number,
  reducers: {
    setEstimateError: (_state, action: PayloadAction<boolean | number>) => action.payload,
  },
});

const estimateAdditionalCostSlice = createSlice({
  name: "estimateAdditionalCost",
  initialState: [] as AdditionalCostItem[],
  reducers: {
    setAdditionalCost: (_state, action: PayloadAction<AdditionalCostItem[]>) => action.payload,
  },
});

const additionalCostTotalSlice = createSlice({
  name: "additionalCostTotal",
  initialState: 0,
  reducers: {
    setEstimateAdditionalCostTotal: (_state, action: PayloadAction<number>) => action.payload,
  },
});

const dateVersionSlice = createSlice({
  name: "dateVersion",
  initialState: [] as EstimateVersionEntry[],
  reducers: {
    getEstimateDateversion: (_state, action: PayloadAction<EstimateVersionEntry[]>) => action.payload,
  },
});

const estimateDataSlice = createSlice({
  name: "estimateData",
  initialState: {} as EstimateData,
  reducers: {
    setEstimateData: (_state, action: PayloadAction<EstimateData>) => action.payload,
  },
});

const estimateFieldsNeedToRefreshSlice = createSlice({
  name: "estimateFieldsNeedToRefresh",
  initialState: estimateFieldsNeedToRefreshIntialState,
  reducers: {
    setEstimateFieldsNeedtoRefresh: (_state, action: PayloadAction<EstimateFieldsNeedToRefresh>) => action.payload,
  },
});

export const { getEstimateList, emptyEstimateList } = estimateListSlice.actions;
export const { setAdditionalCost } = estimateAdditionalCostSlice.actions;
export const { setEstimateAdditionalCostTotal } = additionalCostTotalSlice.actions;
export const { getEstimateDateversion } = dateVersionSlice.actions;
export const { setEstimateData } = estimateDataSlice.actions;
export const { setEstimateFieldsNeedtoRefresh } = estimateFieldsNeedToRefreshSlice.actions;
export const { setEstimateError } = estimateErrorSlice.actions;

export const estimateList = estimateListSlice.reducer;
export const getEstimateAdditionalCost = estimateAdditionalCostSlice.reducer;
export const additionalCostTotal = additionalCostTotalSlice.reducer;
export const getDateVersion = dateVersionSlice.reducer;
export const estimateData = estimateDataSlice.reducer;
export const estimateFieldsNeedToRefresh = estimateFieldsNeedToRefreshSlice.reducer;
export const estimateErrorReducer = estimateErrorSlice.reducer;

export default {
  estimateList,
  getEstimateAdditionalCost,
  additionalCostTotal,
  getDateVersion,
  estimateData,
  estimateFieldsNeedToRefresh,
  estimateErrorReducer,
};
